<template>
	<div class="c-property-listing">
		<div class="c-property-filter">
			<div class="c-property-filter__hero-wrapper">
				<img class="c-property-filter__hero-image" :src="banner()" loading="lazy" />
			</div>
			<div class="c-property-filter__filter-wrapper">
				<h1 class="c-property-filter__title">{{title()}}</h1>
				<fieldset class="c-property-filter__wrapper">

					<!-- Keywords -->
					<div class="c-property-filter__option half">
						<label for="person-keyword">Keyword Search</label>
						<div class="c-property-filter__input">

							<SearchInput v-model="filterState.query"
										 @keyup.enter="apply"
										 placeholder="Search Our Latest Rentals - Enter Suburb, ID, Agent or Keyword"
										 class="search-input-wrapper"
										 :search-icon="true"
										 :shortcut-icon="true"
										 :clearIcon="true"
										 :clearOnEsc="true">

								<template #append-outer>
									<button class="btn btn-primary btn-search" @click="apply()">
										Search
									</button>
								</template>

							</SearchInput>
						</div>
					</div>

					<!-- Location -->
					<div class="c-property-filter__option quarter">
						<label for="location">Location/ Region</label>
						<div class="c-property-filter__input">
							<VueMultiselect v-model="filterState.region"
											:options="filterOptions.regions"
											@update:model-value="apply()"
											:multiple="false"
											placeholder="All regions">
							</VueMultiselect>
						</div>
					</div>

					<!-- Suburbs -->
					<div class="c-property-filter__option quarter">
						<label for="suburb">Suburbs</label>
						<div class="c-property-filter__input">
							<VueMultiselect v-model="filterState.suburbs"
											:options="filterOptions.suburbs"
											@update:model-value="apply()"
											:multiple="true"
											:max="4"
											placeholder="All suburbs"
											:close-on-select="false">
							</VueMultiselect>
						</div>
					</div>

					<!-- Bedrooms -->
					<div class="c-property-filter__option quarter split">
						<label for="bedroom">Bedrooms</label>
						<div class="c-property-filter__input split">
							<VueMultiselect v-model="filterState.bedroomsFrom"
											placeholder="Min"
											:options="this.rooms"
											@update:model-value="trimRooms(), apply()"
											:multiple="false">
							</VueMultiselect>
							<VueMultiselect v-model="filterState.bedroomsTo"
											placeholder="Max"
											:options="this.maxrooms"
											@update:model-value="apply()"
											:multiple="false">
							</VueMultiselect>
						</div>
					</div>

					<!-- Bathrooms -->
					<div class="c-property-filter__option quarter">
						<label for="bathroom">Bathrooms</label>
						<div class="c-property-filter__input">
							<VueMultiselect v-model="filterState.bathroomsFrom"
											placeholder="Any bathrooms"
											:options="this.rooms"
											@update:model-value="apply()"
											:multiple="false">
							</VueMultiselect>
						</div>
					</div>

					<!-- Price -->
					<div class="c-property-filter__option quarter">
						<label for="price">Price</label>
						<div class="c-property-filter__input split">
							<VueMultiselect v-model="filterState.PriceFrom"
											placeholder="From"
											:options="this.price"
											@update:model-value="trimPrice(), apply()"
											:custom-label="formatCurrency"
											:multiple="false">
							</VueMultiselect>
							<VueMultiselect v-model="filterState.PriceTo"
											placeholder="To"
											:options="this.maxprice"
											@update:model-value="apply()"
											:custom-label="formatCurrency"
											:multiple="false">
							</VueMultiselect>
						</div>
					</div>

					<!-- Other -->
					<div class="c-property-filter__option quarter">
						<label for="other">Other Criteria</label>
						<div class="c-property-filter__input">
							<VueMultiselect v-model="filterState.other"
											placeholder="Other criteria"
											:options="filterOptions.otherCriteria"
											label="value"
											track-by="value"
											@update:model-value="apply()"
											:multiple="true">
							</VueMultiselect>
						</div>
					</div>
				</fieldset>
			</div>
		</div>

		<!--  Results Container  -->
		<div class="c-property-summary">
			<div class="c-property-summary__wrapper">
				<div class="c-property-split filtersbuttons">
					<div class="c-property-tags-wrapper" v-if="Object.keys(currentSelections).length > 0">
						<div class="c-property-tags">
							<button class="c-property-tags__buttons" v-for="selection in currentSelections" @click="setState(selection.state)">
								{{selection.label}}
								<span class="iconf-close"></span>
							</button>
						</div>
						<button class="c-property-tags__reset" @click="resetState()">
							<span class="iconf-reload"></span>
							Reset
						</button>
					</div>
					<div v-else></div>

					<!--<div class="c-property-subscribe">
						<div class="c-property-subscribe__text">
							Notify me when properties are listed that meet the current search criteria
						</div>
						<button class="c-property-subscribe__button js-modal__trigger" aria-controls="modal-property">
							<span class="iconf-email"></span>
							Subscribe to Email Alert
						</button>
					</div>-->
				</div>
				<div class="c-property-split">
					<div class="c-property-results">
						<div class="c-filter-summary__count" v-if="Meta">We found <b>{{Meta.totalItemCount}}</b> results for rental that matches your criteria.</div>
					</div>
					<div class="c-property-sort c-form">
						<div class="c-property-sort__label">Sort by</div>
						<select class="c-property-sort__select" v-model="filterState.sortBy" @change="apply()">
							<option v-for="option in sorts"
									v-bind:value="option.value"
									:selected="option === this.filterState.sortBy">
								{{ option.name }}
							</option>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div class="c-property-results">
			<div class="c-property-results__container">
				<transition-group name="propertycard">
					<property-card :property="property" v-for="property in Properties" :key="property"></property-card>
				</transition-group>
			</div>
		</div>
		<div class="c-property-pagination">
			<div class="pagi" v-if="pages.length">
				<button class="pagi-button pagi-prev" :disabled="pagiprev" @click="setPage(filterState.page - 1)">
					<span class="iconf-arrow-left"></span>
					<span class="c-pagination__text">Previous</span>
				</button>
				<button class="pagi-num" :class="{ 'is-selected' : filterState.page === page }" @click="setPage(page)" v-for="page in pages">{{page}}</button>
				<button class="pagi-button pagi-next" :disabled="paginext" @click="setPage(filterState.page + 1)">
					<span class="c-pagination__text">Next</span>
					<span class="iconf-arrow-right"></span>
				</button>
			</div>
		</div>
	</div>
	<div class="c-modal c-property-modal js-modal" id="modal-property" aria-modal="true" role="dialog" data-modal-body-open-class="c-modal__body-open--full">
		<div class="c-modal__body js-modal__body">
			<button class="c-modal__close js-modal__close" ref="ModalClose" aria-label="Close">
				Close
				<span class="iconf-close"></span>
			</button>
			<div class="c-property-modal__wrapper">
				<div class="c-property-modal__header">
					<span class="iconf-email"></span>
					Receive Property Spotter Emails
				</div>
				<div class="c-property-modal__description-wrapper">
					<div class="c-property-modal__description">
						Notify me when properties are listed that meet the current search criteria.
					</div>
					<div class="c-property-modal__criteria-wrapper" v-if="Object.keys(currentSelections).length > 0">
						Your criteria:
						<div class="c-property-modal__criteria" v-for="selection in currentSelections">
							{{selection.label}}
							<span>,</span>
						</div>
					</div>
				</div>
				<div class="c-property-modal__form">
					<form class="c-form" @submit.prevent="handleSubmit">
						<div class="c-form__fields-set">
							<div class="c-form__field-group">
								<div class="c-form__field">
									<label class="c-form__label" for="Name">Full name*</label>
									<input class="c-form__input" name="Name" type="text" v-model="postData.Name" required placeholder="Name">
								</div>
								<div class="c-form__field">
									<label class="c-form__label" for="Email">Email Address*</label>
									<input class="c-form__input" name="Email" type="email" v-model="postData.Email" required placeholder="Email">
								</div>
								<div id="recaptcha" class="g-recaptcha" style="display:none;"></div>
								<div class="c-form__field">
									<button class="c-form__control" @click="fireForm">Alert Me</button>
								</div>
								<div class="c-form__field has-error">
									<p class="c-form__note c-form__error-message" v-if="noSearch">Please select filter criteria in the property search.</p>
									<p class="c-form__note c-form__error-message" v-if="noValues">Please fill in both Full name and Email address.</p>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
		<span class="c-modal__dummy" tabindex="0"><!-- Dummy focusable element --></span>
	</div>

</template>

<script>
	import SearchInput from 'vue-search-input';
	import VueMultiselect from 'vue-multiselect';

	import DataSource from 'Vue/components/data-listing.js';
	import information from 'Vue/components/dataProperties.js';


	export default {
		name: 'property-listing',
		components: {
			SearchInput,
			VueMultiselect
		},
		//props: ['data', 'api', 'title', 'banner', 'formaction', 'recapchakey', 'verification'],
		data() {
			return {
				filterState: {
					query: '',
					region: '',
					suburbs: [], // string[]
					bedroomsFrom: '',
					bedroomsTo: '',
					bathroomsFrom: '',
					PriceFrom: '',
					PriceTo: '',
					page: 1,
					sortBy: '0',
					other: [] // { key: string, value: string }
				},
				rooms: [1, 2, 3, 4, 5, 6, 7, 8, 9],
				maxrooms: [],
				price: [50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000, 1050, 1100, 1150, 1200, 1250, 1300, 1350, 1400, 1450, 1500, 1550, 1600, 1650, 1700, 1750, 1800, 1850, 1900, 1950, 2000, 2050, 2100, 2150, 2200, 2250, 2300, 2350, 2400, 2450, 2500, 2550, 2600, 2650, 2700, 2750, 2800, 2850, 2900, 2950, 3000, 3050, 3100, 3150, 3200, 3250, 3300, 3350, 3400, 3450, 3500],
				maxprice: [],
				sorts: [{
					name: 'Newest First',
					value: '0'
				},
				{
					name: 'Oldest First',
					value: '1'
				},
				{
					name: 'Highest Price First',
					value: '2'
				},
				{
					name: 'Lowest Price First',
					value: '3'
				}],
				pages: [],
				Properties: [], // object - reduced set of property items used for render
				Meta: null,
				currentSelections: [], // object - current filters in use can be removed individualy
				filterOptions: {
					suburbs: [], // string[]
					regions: [], // string[]
					otherCriteria: [], // [] {Key,Value}
				},
				otherItems: '',
				sortOrder: '0',
				postData: {
					Name: '',
					Email: '',
					Keyword: '',
					Suburb: '',
					City: '',
					Bedrooms: '',
					Bathrooms: '',
					PriceFrom: '',
					PriceTo: '',
					Advanced: '',
				},
				noSearch: false,
				noValues: false,
			}
		},
		mounted() {
			console.log({ information });
			this.filterState = DataSource.getFilterState();
			if (typeof this.filterState.sortBy === 'number') {
				this.filterState.sortBy = this.filterState.sortBy + '';
			}
			this.mount(information.data);
			DataSource.init(information.api);   //------------------   api source
			this.trimPrice();
			this.trimRooms();
			this.initReCaptcha();
		},
		watch: {
			filterState(newValue, oldValue) {
				console.log('filterState changed:', newValue, oldValue);
			}
		},
		computed: {
			pagiprev() {
				if (this.filterState.page === 1) {
					return true
				}
			},
			paginext() {
				var lastpage = this.Meta.pageCount;
				if (this.filterState.page === lastpage) {
					return true
				}
			},
			hasAnyValue() {
				const { Name, Email, ...excludedObject } = this.postData;
				return Object.values(excludedObject).some(value => value); // Returns true if any value is truthy
			},

		},
		methods: {
			mount(data) {
				this.filterOptions = JSON.parse(JSON.stringify(data.filterOptions));
				this.Properties = data.items;	//------------------   data source
				this.Meta = data.meta;
				this.filterState.page = data.meta.pageNumber;

				let pages = [];
				let start = Math.max(1, Math.min(data.meta.pageCount - 4, data.meta.pageNumber - 2));
				let end = Math.min(data.meta.pageCount, Math.max(data.meta.pageNumber + (5 - data.meta.pageNumber), data.meta.pageNumber + 2));

				for (let i = start; i <= end; i++) {
					pages.push(i);
				}

				this.pages = pages;

				if (this.pages.length < 2) {
					this.pages = [];
				}

				this.buildSummary();			},
			apply(KeepPageNumber) {

				if (!KeepPageNumber) {
					this.filterState.page = 1; // reset page number
				}

				let result = DataSource.apply(JSON.parse(JSON.stringify(this.filterState)));
				let mount = this.mount;

				result.then(function (data) {
					mount(data);
				});
			},
			banner() {
				return information.banner; // Banner image path
			},
			title() {
				return information.title; // Title of the property listing
			},
			trimRooms() {

				let options = JSON.parse(JSON.stringify(this.rooms));

				options = options.filter(x => {
					return this.filterState.bedroomsFrom <= x;
				});

				this.maxrooms = options;

				if (options.includes(this.filterState.bedroomsTo) === false) {
					this.filterState.bedroomsTo = '';
				}
			},
			trimPrice() {

				let options = JSON.parse(JSON.stringify(this.price));

				options = options.filter(x => {
					return this.filterState.PriceFrom <= x;
				});

				this.maxprice = options;

				if (options.includes(this.filterState.PriceTo) === false) {
					this.filterState.PriceTo = '';
				}
			},
			buildSummary() {
				this.currentSelections = [];

				if (this.filterState.query.length > 0) {
					let state = JSON.parse(JSON.stringify(this.filterState));
					state.query = '';

					this.currentSelections.push({
						label: `Matching "${this.filterState.query}"`,
						state: state
					});
				}

				if (this.filterState.region.length > 0) {
					let state = JSON.parse(JSON.stringify(this.filterState));
					state.region = '';

					this.currentSelections.push({
						label: this.filterState.region,
						state: state
					});
				}

				if (this.filterState.suburbs.length > 0) {
					for (let i = 0, l = this.filterState.suburbs.length; i < l; i++) {

						let sub = this.filterState.suburbs[i];
						let other = Array.from(this.filterState.suburbs).filter(x => x !== sub);
						let state = JSON.parse(JSON.stringify(this.filterState));
						state.suburbs = other;

						this.currentSelections.push({
							label: sub,
							state: state
						});
					}
				}

				if (this.filterState.bedroomsFrom > 0 || this.filterState.bedroomsTo > 0) { // either bedroomsFrom or bedroomsTo is set
					let state = JSON.parse(JSON.stringify(this.filterState));
					state.bedroomsFrom = 0;
					state.bedroomsTo = 0;

					if (this.filterState.bedroomsFrom > 0 && this.filterState.bedroomsTo > 0) { // both bedroomsFrom and bedroomsTo are set
						if (this.filterState.bedroomsFrom === this.filterState.bedroomsTo) { // if both are equal, we display a single bedroom count
							this.currentSelections.push({
								label: `${this.filterState.bedroomsFrom} bedroom`,
								state: state
							});
						} else {
							this.currentSelections.push({
								label: `${this.filterState.bedroomsFrom} - ${this.filterState.bedroomsTo} bedrooms`,
								state: state
							});
						}
					} else {
						if (!(this.filterState.bedroomsTo > 0)) { // if bedroomsTo is not set, we only have bedroomsFrom set
							this.currentSelections.push({
								label: `Min ${this.filterState.bedroomsFrom} bedrooms`,
								state: state
							});
						} else { // if bedroomsFrom is not set, we only have bedroomsTo set
							this.currentSelections.push({
								label: `Max ${this.filterState.bedroomsTo} bedrooms`,
								state: state
							});
						}
					}
				}

				if (this.filterState.bathroomsFrom > 0) {
					let state = JSON.parse(JSON.stringify(this.filterState));
					state.bathroomsFrom = '';

					this.currentSelections.push({
						label: `${this.filterState.bathroomsFrom}+ bathrooms`,
						state: state
					});
				}

				if (this.filterState.PriceFrom > 0 || this.filterState.PriceTo > 0) {
					let state = JSON.parse(JSON.stringify(this.filterState));
					state.PriceFrom = 0;
					state.PriceTo = 0;

					if (this.filterState.PriceFrom > 0 && this.filterState.PriceTo > 0) {
						if (this.filterState.PriceFrom === this.filterState.PriceTo) {
							this.currentSelections.push({
								label: `$${this.filterState.PriceTo} per week`,
								state: state
							});
						} else {
							this.currentSelections.push({
								label: `$${this.filterState.PriceFrom} - $${this.filterState.PriceTo} per week`,
								state: state
							});
						}
					} else {
						if (!(this.filterState.PriceTo > 0)) {
							this.currentSelections.push({
								label: `From $${this.filterState.PriceFrom} per week`,
								state: state
							});
						} else {
							this.currentSelections.push({
								label: `To $${this.filterState.PriceTo} per week`,
								state: state
							});
						}
					}
				}

				if (this.filterState.other.length > 0) {

					for (let i = 0, l = this.filterState.other.length; i < l; i++) {

						let other = this.filterState.other[i];
						let otherItems = Array.from(this.filterState.other).filter(x => x !== other);
						let state = JSON.parse(JSON.stringify(this.filterState));

						state.other = otherItems;

						this.currentSelections.push({
							label: other.value,
							state: state
						});
					}
				}

				this.postData.Keyword = this.filterState.query || '';
				this.postData.Suburb = this.filterState.suburbs.length > 0 ? this.filterState.suburbs.join(',') : '';
				this.postData.City = this.filterState.region || '';
				this.postData.Bedrooms = this.filterState.bedroomsFrom || this.filterState.bedroomsTo ? `${this.filterState.bedroomsFrom}-${this.filterState.bedroomsTo}` : '';
				this.postData.Bathrooms = this.filterState.bathroomsFrom || '' ? this.filterState.bathroomsFrom : '';
				this.postData.PriceFrom = this.filterState.PriceFrom || '';
				this.postData.PriceTo = this.filterState.PriceTo || '';
				this.postData.Advanced = this.filterState.other.length > 0 ? this.filterState.other.map(x => x.value).join(',') : '';
			},
			setState(state) {
				this.filterState = state;
				this.apply();
			},
			resetState() {
				this.filterState = {
					query: '',
					region: '',
					suburbs: [], // string[]
					bedroomsFrom: '',
					bedroomsTo: '',
					bathrooms: '',
					PriceFrom: '',
					PriceTo: '',
					page: 1,
					sortBy: '0',
					other: [] // { key: string, value: string }
				};
				this.apply();
			},
			setPage(num) {
				this.filterState.page = num;
				this.apply(true);
			},
			formatCurrency(value) {
				var formatter = new Intl.NumberFormat('en-NZ', {
					style: 'currency',
					currency: 'NZD',
					minimumFractionDigits: 0,
					maximumFractionDigits: 0
				});
				return formatter.format(value);
			},
			initReCaptcha: function () {
				if (typeof grecaptcha === 'undefined') {
					var script = document.createElement('script');
					script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
					script.onload = this.renderWait;
					document.head.appendChild(script);
				} else {
					this.renderReCaptcha();
				}
			},
			renderWait() {
				setTimeout(() => {
					if (typeof grecaptcha !== "undefined" && typeof grecaptcha.render !== "undefined") this.renderReCaptcha();
					else this.renderWait();
				}, 200);
			},
			renderReCaptcha: function () {
				var self = this;
				setTimeout(function () {
					grecaptcha.render('recaptcha', {
						sitekey: information.recapchakey,
						size: 'invisible',
						badge: 'inline',
						callback: self.submitData
					});
				}, 100);
			},
			fireForm: function () {
				if (this.hasAnyValue) {
					this.noSearch = false; // We have some search criteria selected
					if (this.postData.Name === '' || this.postData.Email === '') {
						this.noValues = true; // No values in the form fields, show error message
					} else {
						grecaptcha.execute();
						this.noValues = false; // We have values in the form fields
					}
				} else {
					this.noSearch = true; // No search criteria selected
				}
			},
			async submitData(token) {
				var Destination = information.formaction;

				try {
					var formdata = new FormData();

					// Append all fields from postData
					for (const key in this.postData) {
						if (Object.prototype.hasOwnProperty.call(this.postData, key)) {
							formdata.append(key, this.postData[key]);
						}
					}

					formdata.append('g-recaptcha-response', token);
					formdata.append('__RequestVerificationToken', information.verification); // Append verification if it exists

					const response = await fetch(Destination, {
						method: 'POST',
						body: formdata
					});
					if (response.ok) {
						alert('Thank you for subscribing! You will receive email alerts for properties matching your criteria.');
					}
					if (!response.ok) {
						const errorText = await response.text();
						alert('An error occured and could not complete the submission.');
						throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
					}
					const result = await response;
				} catch (error) {
					console.error('Error:', error);
				} finally {
					this.postData.name = '';
					this.postData.email = '';
					this.$refs.ModalClose.click(); // Close the modal after submission
				}
			}
		}
	};
</script>